import { useContext } from 'react';
import cx from 'classnames';
import { Text } from '@intellecteu/common-ui';
import { useFormikContext } from 'formik';
import { isEmpty } from 'app/utils';
import { StepperContext, TStepperContext } from '../context';
import { Step } from '../types';

import s from './styles.module.scss';

type StepperProps = {
  steps: Step[];
  currentIndex: number;
};

const Stepper = ({ steps, currentIndex }: StepperProps) => {
  const { errors } = useFormikContext();
  const { hasStepError } = useContext<TStepperContext>(StepperContext);

  return (
    <ul className={s.steps}>
      {steps?.map((el, index) => {
        return (
          <li className={s.step} key={`step-${el.label}-${index}`}>
            <Text
              className={cx(
                s.stepNumber,
                currentIndex === index && s.stepNumberActive,
                index < currentIndex && s.stepNumberPassed,
                hasStepError(el.id) && !isEmpty(errors) && s.stepNumberError,
              )}
              size="xxs"
              weight="bold"
            >
              {index + 1}
            </Text>

            {currentIndex === index && (
              <Text size="xs" weight="bold" className={s.label}>
                {el.label}
              </Text>
            )}

            <div className={s.stepDivider} />
          </li>
        );
      })}
    </ul>
  );
};
export { Stepper };
